module.exports = __webpack_public_path__ + "img/hic-cancer-female.1290f348.png";